<div ui-row uiJustify="center">
  <div class="sp-px-12" ui-col>
    <div class="sp-mb-24" ui-row uiJustify="center">
      <div ui-col>
        <i class="main-icon" uiType="blocked" uiTheme="fill" ui-icon></i>
      </div>
    </div>
    <div ui-row uiJustify="center">
      <div ui-col>
        <h4 class="title text-color-gray-13 fs-30px">{{ "unable_to_create_key_results" | localize }}</h4>
        <p class="description sp-mt-24 sp-mb-32 text-color-gray-13 fs-14px">
          <span *ngIf="metricsLimitReached" data-test-id="metrics-limit-reached-message">
            {{ "method_champ_max_metrics_goal" | localize : { metricsLimit } }}
            {{ "goal_has_metrics" | localize : { length: goal.metrics.length } }}
          </span>
          <span *ngIf="goal.locked && session.workflow && !session.workflow.editableKrFields">
            {{ "goal_status_draft_or_session_status_open" | localize }}
            <span *ngIf="goal.workflow.status === 'inReview'"> {{ "in_review" | localize }}.</span>
            <span *ngIf="goal.workflow.status === 'notEnoughReviewers'"> {{ "needs_reviewers" | localize }}.</span>
            <span *ngIf="goal.workflow.status === 'approved'"> {{ "approved" | localize }} .</span>
          </span>
          <span *ngIf="goal.locked && !session.workflow">
            {{ "session_status_not_opened" | localize }}
            <span *ngIf="session.status === 'closed'"> {{ "archived" | localize }}.</span>
            <span *ngIf="session.status === 'locked'"> {{ "in_progress" | localize }}.</span>
          </span>
        </p>
      </div>
    </div>
  </div>
  <div *ngIf="!session?.workflow?.editableKrFields">
    <button [uiSuccess]="true" (click)="dismiss.emit()" (keydown.enter)="dismiss.emit()" ui-button uiSize="large" uiType="primary" uiShape="round" aria-describedby="metrics-limit-reached">
      {{ "got_it" | localize }}
    </button>
  </div>
</div>
